<template lang="pug">
  div(v-html="extra && extra.content")

</template>

<script>
export default {
  props: ['extra']
}
</script>
